export enum AccountCreationMethod {
  Unknown = 0
}
